

export class ApprovalRequest {


    public productId: number;
    public approvalFlag: number;

     constructor(approvalRequest: any) {
         this.productId = approvalRequest.productId || '';
         this.approvalFlag = approvalRequest.approvalFlag || '';
     }
 }
